import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CALENDAR_EVENTS_ACTION_TYPE } from '../actions';

const initialState = {};

const calendarEventsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case CALENDAR_EVENTS_ACTION_TYPE.GET_CALENDAR_EVENTS:
        return payload || initialState;

      case CALENDAR_EVENTS_ACTION_TYPE.CREATE_CALENDAR_EVENT:
      case CALENDAR_EVENTS_ACTION_TYPE.EDIT_CALENDAR_EVENT:
        draft[payload.calendarEventId] = payload;
        break;

      case CALENDAR_EVENTS_ACTION_TYPE.DELETE_CALENDAR_EVENT:
        delete draft[meta.calendarEventId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default calendarEventsReducer;
